// extracted by mini-css-extract-plugin
export var BannerWrap = "index-module--BannerWrap--Y-G4T";
export var ButtonQrcodeWrap = "index-module--ButtonQrcodeWrap--KvFTl";
export var GropeSwiper = "index-module--GropeSwiper--Yjcff";
export var GropeWrap = "index-module--GropeWrap--nBHMl";
export var GropeWrapMobileButton = "index-module--GropeWrapMobileButton--bB2Ji";
export var SchemeContainer = "index-module--SchemeContainer--SuRIV";
export var SolutionsSwiper = "index-module--SolutionsSwiper--TX51X";
export var SolutionsSwiperMobile = "index-module--SolutionsSwiperMobile--NVQUZ";
export var SolutionsSwiperMobileButton = "index-module--SolutionsSwiperMobileButton--W4QVH";